import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SecondaryButton from 'src/Components/SecondaryButton/SecondaryButton';

import './styles.scss';
import { GE_DOMAIN } from 'src/Config/constants';

const DataType = Object.freeze({
  STRING: 'string',
  BUTTON: 'button',
  CUSTOM: 'custom',
  LINK: 'link',
  ARRAY: 'array',
});

export const DeviceType = Object.freeze({
  Tablet: 768,
  Desktop: 1140,
  Phone: 599
});

const TableRow = ({
  customRendering,
  dataRow,
  columns,
  indexKey,
  selectButtonHandler,
  clickHandler,
  handleClickNavigate,
  accordionColumns,
  isMobile
}) => {
  const [open, setOpen] = useState(false);
  const loginType = localStorage.getItem('loginType');
  let pageType;
  if(loginType === GE_DOMAIN) pageType = "customer";
  else pageType = "account";

  const handleRowClick = (e) => {
    handleClickNavigate(dataRow);
  }

  const handleCollapseClick = () => {
    setOpen(!open);
  }

  const getDataRowStatus = (datarow) => {
    return !(datarow?.status !== 'offline' || datarow?.active);
  }

  const getRowStatus = (datarow, pageType) => {
    return !(pageType === 'account' || (datarow?.status !== 'offline' && datarow?.active));
  }

  const displayRowCell = (column, uniqueKey, pageType, selectButtonHandler, isColHidden, datarow) => {

    let buttons = [];
    let datarowStatus = getDataRowStatus(datarow);
    let rowStatus = getRowStatus(datarow, pageType)

    if (column.buttonsArray?.length > 0 && pageType != 'customer' )  {
      column.buttonsArray.map((x, index) => {
        let icon = x.iconName ? x.iconName : '';
        buttons.push(<SecondaryButton key={x.iconName} text={x.buttonText} onClick={selectButtonHandler} styleType={'stroked-secondary'} icon={icon} disabled={datarowStatus} />)
      })

      return (<div key={`button-${uniqueKey}-btns`} className={`table-row__container row-${column.widthInPercent} ${isColHidden} `} ><div className='gutter-padding'>{buttons}</div></div>)
    }
    else if(pageType != 'customer'){
      let icon = column.iconName ? column.iconName : '';
      return (
        <div key={`button-${uniqueKey}`} className={`table-row__container row-${column.widthInPercent} ${isColHidden}`} >
        <div className = 'gutter-padding'>
          <SecondaryButton text={column.buttonText} onClick={selectButtonHandler} styleType={'stroked-secondary'} icon={icon} disabled={rowStatus} /></div>
        </div>
      )
    }
  }

  const getColHidden = (column) => {
    if(column.isHidden){
      return 'hide';
    }else{
      return ''
    }
  }

  const getColClassName = (column) => {
    if(column.className){
      return column.className;
    }else{
      return ''
    }
  }

  const getColFieldName = (datarow, column) => {
    if(datarow[column.fieldName]?.length > 0 && datarow[column.fieldName] != "null"){
      return datarow[column.fieldName];
    }else{
      return '-';
    }
  }

  const getStringRowCell = (uniqueKey, datarow, column, colFieldName, isColHidden, colClassName) => {
    let rowCell;
    Object.keys(datarow).forEach(function eachKey(key) {
      if (key === column.fieldName) {
        rowCell = (
            <div key={`${uniqueKey}`}
              className={`table-row__container row-${column.widthInPercent}`}
            >
              <div className='gutter-padding'>
                <span className={`table-row__cell-label table-row__cell-label-wrap ${isColHidden} ${colClassName}`}>
                  {colFieldName}
                </span>
              </div>
            </div>
          )
        }
    });
    return rowCell;
  }

  const getStringWithTitle = (uniqueKey, datarow, column, colFieldName, isColHidden, colClassName) => {
    let rowCell;
    Object.keys(datarow).forEach(function eachKey(key) {
      if (key === column.fieldName) {
        rowCell = (
          <div key={`${uniqueKey}`}
            className={`table-row__container row-${column.widthInPercent}`}
          >
            <span className={`table-row__cell-header`}>{column.title}</span> <br />
                <span className={`table-row__cell-label table-row__cell-label-wrap ${isColHidden} ${colClassName}`}>
                  {colFieldName}
            </span>
          </div>
        );
      }
    });
    return rowCell;
  }

  const getLinkRow = (datarow, column, colClassName) => {
    let link = getLink(datarow, column); 

    return (
      <div key={`link-${uniqueKey}`} className={`table-row__container row-${column.widthInPercent} ${isColHidden} `}>
        <a className={`table-row__cell-link ${colClassName}`} href={link} onClick={(e) => clickHandler(e, column)} >{datarow[column.fieldName]}</a>
      </div>
    )
  }

  const getLink = (datarow, column) => {
    if(column.linkUrl?.indexOf('tel') > -1) return column.linkUrl.concat(datarow[column.fieldName]);
    else return '#';
  }

  const getArrayRowCell = (datarow, column, uniqueKey, isColHidden) => {
    let arrList = getArrList(datarow, column);
    const data = arrList.map((val) => val.modality).join(', ');

    return (
      <div key={`${uniqueKey}`} className={`table-row__container row-${column.widthInPercent} ${isColHidden}`} >
        <span className={`table-row__cell-label table-row__cell-label-wrap ${isColHidden}`}>
          {data.length > 0
            ? data
            : ''}
        </span>
      </div>
    )
  }

  const getArrList = (datarow, column) => {
    if(datarow[column.fieldName]?.length > 0) return datarow[column.fieldName];
    else return [];
  }

  const getRowCell = (column, datarow, uniqueKey) => {
    let rowCell;

    if (!isMobile && open) {
      setOpen(!open);
    }

    let isColHidden = getColHidden(column);
    let colClassName = getColClassName(column);
    let colFieldName = getColFieldName(datarow, column);
    switch (column.dataType) {
      case DataType.STRING.toLowerCase():
            rowCell = getStringRowCell(uniqueKey, datarow, column, colFieldName, isColHidden, colClassName);
        break;
      case DataType.BUTTON.toLowerCase(): 
        rowCell = displayRowCell(column, uniqueKey, pageType, selectButtonHandler, isColHidden, datarow);
        break;
      case DataType.LINK.toLowerCase():
        rowCell = getLinkRow(datarow, column, colClassName);
        break;
      case DataType.CUSTOM.toLowerCase():
        rowCell = customRendering(datarow[column.fieldName], column, uniqueKey, indexKey, datarow);
        break;
      case DataType.ARRAY.toLowerCase():
        rowCell = getArrayRowCell(datarow, column, uniqueKey, isColHidden);
        break;
    }
    return rowCell;
  }

  const getAccordionRowCell = (column, datarow, uniqueKey) => {
    let rowCell;

    let isColHidden = getColHidden(column);
    let colClassName = getColClassName(column);
    let colFieldName = getColFieldName(datarow, column); 

    switch (column.dataType) {
      case DataType.STRING.toLowerCase():
        rowCell = getStringWithTitle(uniqueKey, datarow, column, colFieldName, isColHidden, colClassName);
        break;
      case DataType.BUTTON.toLowerCase(): 
        rowCell = displayRowCell(column, uniqueKey, pageType, selectButtonHandler, isColHidden, datarow)
        break;
      case DataType.LINK.toLowerCase():
        rowCell = getLinkRow(datarow, column, colClassName);
        break;
      case DataType.CUSTOM.toLowerCase():
        rowCell = (
          <div key={`${uniqueKey}`}
            className={`table-row__container row-${column.widthInPercent}`}
          >
            <span className={`table-row__cell-header`}>{column.title}</span> <br />
            {customRendering(datarow[column.fieldName], column, uniqueKey, indexKey, datarow)}
          </div>
        )
        break;
      case DataType.ARRAY.toLowerCase():
        rowCell = getArrayRowCell(datarow, column, uniqueKey, isColHidden);
        break;
    }
    return rowCell;
  }

  const getIconName = () => {
    if(open) return "angle-up";
    else return "angle-down";
  }

  let iconName = getIconName();

  return (
    <>
      <div className='table-row' onClick={handleRowClick}>
        {accordionColumns?.length > 0 && isMobile && (
          <div className="collapse-row" onClick={handleCollapseClick}>
            <h3 className="collapse-caret">
              <FontAwesomeIcon icon={iconName} /></h3>
            {getRowCell(columns[0], dataRow, `${indexKey}`)}
          </div>
        )}
        {open && (
          <div className="table-row-extended">
            {accordionColumns.map((column, id) => {
              const uniqueKey = `${indexKey}-${column.key}`;
              return getAccordionRowCell(column, dataRow, uniqueKey);
            })
            }
          </div>
        )}
        {!isMobile && columns.map((column, id) => {
          const uniqueKey = `${indexKey}-${id}`;
          return getRowCell(column, dataRow, uniqueKey);
        })}
      </div>
    </>
  );
}

export default TableRow;